// USERCENTRICS_CUSTOM_CONSENT_EVENT_NAME must match the event name used in Usercentrics configuration
// https://support.usercentrics.com/hc/en-us/articles/17484523116572-Communicating-consent-information-to-third-party-applications
export const USERCENTRICS_CUSTOM_CONSENT_EVENT_NAME =
  "usercentricsConsentEvent";
